{
  "AllNotifications": "모든 알림",
  "NoLinkNotification": "사용 가능한 이 알림의 링크 없음",
  "ViewAllAnnouncementTab": "공지사항",
  "ViewallNotificationTab": "알림",
  "preferences": "환경 설정 편집"
}
